import { render } from "./message-table-filter.vue?vue&type=template&id=b94f9a50"
import script from "./message-table-filter.vue?vue&type=script&lang=js"
export * from "./message-table-filter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__